import { HttpRequestBuilder } from '@jutro/transport';
import appConfig from 'app-config';

import { basicAuthOptions } from '@jutro/legacy/transport';

const { PitneyBowesSettings, runtimeEnv = '' } = appConfig;
const metlifeGeoUrl = runtimeEnv === 'prod' ? PitneyBowesSettings.serviceBaseURLs.metlifeGeoComplete_prod : PitneyBowesSettings.serviceBaseURLs.metlifeGeoComplete;
const validateAddressURL = PitneyBowesSettings.serviceBaseURLs.validateAddress;

const getStates = async (zipCode) => {
    const requestBuilder = new HttpRequestBuilder();
    switch (PitneyBowesSettings.auth.kind) {
        case 'basic':
            requestBuilder.addOptions(basicAuthOptions(PitneyBowesSettings.auth.username,
                PitneyBowesSettings.auth.password));
            break;
        default:
            return null;
    }
    const restService = requestBuilder.build();

    return restService.get(metlifeGeoUrl,
        {
            'Data.PostalCode': zipCode,
            'Data.Country': 'US'
        })
        .then((response) => {
            if (response.output_port.length > 0 && response.output_port[0].StateProvince) {
                return response.output_port;
            }
            throw 'We\'re sorry, we didn\'t recognize that zip code.';
        }, () => {
            throw 'We\'re sorry. Due to technical difficulties, we are unable to process your quote at this time. Please try again later. Thank you.';
        });
};

export default {
    getStates: async (zipCode) => {
        return getStates(zipCode).then((data) => {
            return data.filter((state, pos, states) => {
                return states.map((stateMap) => stateMap.StateProvince)
                    .indexOf(state.StateProvince) === pos;
            });
        });
    },

    getState: async (zipCode) => {
        return getStates(zipCode).then((data) => {
            return data[0];
        });
    },

    retrieveAddress: async (address, data, exludeZip) => {
        const requestBuilder = new HttpRequestBuilder();
        switch (PitneyBowesSettings.auth.kind) {
            case 'basic':
                requestBuilder.addOptions(basicAuthOptions(PitneyBowesSettings.auth.username,
                    PitneyBowesSettings.auth.password));
                break;
            default:
                return null;
        }
        const restService = requestBuilder.build();

        const postalCode = data.postalCode.value ? data.postalCode.value : '';
        const response = await restService.get(metlifeGeoUrl,
            {
                'Data.AddressLine1': address,
                'Data.PostalCode': (exludeZip) || (address.indexOf(data.value.state) !== -1) || (address.indexOf(data.value.postalCode) !== -1) ? '' : postalCode,
                'Data.Country': data.country.value.code,
                'Option.OutputFields': ' HouseNumber,AddressLine1,AddressLine2,PostalCode,City,StateProvince,Status',
                'Option.MaximumResults': '20'
            });

        const formattedResponse = response.output_port.map((item) => {
            return {
                formattedAddress: `${item.AddressLine1} ${item.AddressLine2} ${item.City}, ${item.StateProvince} ${item.PostalCode}`,
                addressData: item
            };
        }).filter((item) => {
            return (item.addressData.AddressLine1 !== '')
                && (item.addressData['Status.Description'] !== 'Geocoded PostalCode only');
        });

        return formattedResponse;
    },

    validateAddress: async (address) => {
        const requestBuilder = new HttpRequestBuilder();
        switch (PitneyBowesSettings.auth.kind) {
            case 'basic':
                requestBuilder.addOptions(basicAuthOptions(PitneyBowesSettings.auth.username,
                    PitneyBowesSettings.auth.password));
                break;
            default:
                return null;
        }

        const restService = requestBuilder.build();
        const response = await restService.get(validateAddressURL,
            {
                'Data.AddressLine1': address.addressLine1,
                'Data.AddressLine2': address.addressLine2,
                'Data.PostalCode': address.postalCode,
                'Data.City': address.city,
                'Data.StateProvince': address.state,
                'Option.MaximumResults': '3',
                'Option.KeepMultimatch': 'Y'
            });

        const filteredResponse = await response.output_port.filter((item) => (item.Status !== 'F') || (item.Status === 'F' && item['Status.Code'] === 'MultipleMatchesFound'));

        return filteredResponse;
    }
};
